import mergeTagModalCreator from '../../../../merge-tags/helpers/merge-tag-modal-creator';
import ticketTemplatePreviewModalCreator from '../../helpers/ticket-template-preview-modal-creator';

export default class TicketTemplateEditorController {
    constructor($scope, $injector) {
        this.scope = $scope;
        this.injector = $injector;

        this.api = this.injector.get('$http');
        this.alert = this.injector.get('Alert');
        this.timeout = this.injector.get('$timeout');
        this.usersStore = this.injector.get('Users');

        this.loading = true;
        this.mediaStartDirectory = _.get(this.usersStore.state, 'company.media.default_directories.tickets', null);
        this.updatingPreview = true;
        this.currentPreviewIndex = 0;
        this.availableFonts = [];

        this.originalTemplate = null;
        this.originalModel = null;
        this.onModelChange = () => {
        };

        this.formConfig = {
            templateAce: null
        };

        this.injector.get('AceEditor').getEditor((editor) => {
            this.formConfig.templateAce = editor;
        });

        this.model = null;
        this.definitionModel = null;
        this.previewRsvpId = null;

        this.templateType = null;

        this.currentContainer = null;
        this.lastBlurInformation = null;
        this.containerElements = {};

        const controllerInstance = this;
        this.enabledQuillModules = {
            toolbar: {
                container: [
                    [{'color': []}],
                    [{
                        'size': [
                            false,
                            '8px',
                            '10px',
                            '12px',
                            '14px',
                            '16px',
                            '18px',
                            '20px',
                            '22px',
                            '24px',
                            '26px',
                            '28px',
                            '30px',
                            '35px',
                            '40px',
                            '45px',
                            '50px'
                        ]
                    }],
                    ['bold', 'italic', 'underline'],
                    [{'list': 'ordered'}, {'list': 'bullet'}],
                    ['al-placeholder']
                ],
                handlers: {
                    'al-placeholder': function () {
                        const quill = this.quill,
                            selection = quill.getSelection(true);

                        controllerInstance._openMergeTagModal()
                            .then(({placeholder}) => {
                                quill.insertText(selection.index, placeholder);
                            })
                            .catch(e => console.error(e))
                    }
                }
            }
        };

        this.quillCustomOptions = [
            {import: 'attributors/style/color'},
            {import: 'attributors/style/font'},
            {import: 'attributors/style/size'}
        ];
    }

    $onInit() {
        this._initWatchers();

        this._updateModelFromOriginalModel();
    }

    changePreviewRsvpId(newRsvpId) {
        this.previewRsvpId = newRsvpId || null;
    }

    triggerPreviewModal() {
        ticketTemplatePreviewModalCreator(this.injector, this.originalTemplate.id, this._prepareModelForApi());
    }

    updateDefinitionModelValue(settingPath, newValue) {
        _.set(this.definitionModel, settingPath, newValue);
        this.scope.$applyAsync();
    }

    handleBlurElement(event) {
        this.lastBlurInformation = {
            element: event.target,
            cursorPosition: event.target.selectionStart
        }
    }

    triggerMergeTagPopUp(event, fieldIdToInsert, modelFieldPath) {
        let cursorPositionToInsert = (this.lastBlurInformation && this.lastBlurInformation.element.id === fieldIdToInsert) ? this.lastBlurInformation.cursorPosition : -1;

        this.lastBlurInformation = null;

        this._openMergeTagModal()
            .then(({placeholder}) => {
                const oldValue = _.get(this.definitionModel, modelFieldPath, '');
                let newValue = oldValue;

                if (cursorPositionToInsert === -1) {
                    newValue += placeholder;
                } else {
                    newValue = [
                        oldValue.slice(0, cursorPositionToInsert),
                        placeholder,
                        oldValue.slice(cursorPositionToInsert)
                    ].join('');
                }

                _.set(this.definitionModel, modelFieldPath, newValue);
            })
            .catch(e => console.error(e))
    }

    goToGlobalSettings() {
        if (this.originalTemplate.type === 'predefined_type') {
            if (!this.currentContainer || !this.containerElements[this.currentContainer.key]) {
                return;
            }

            this.containerElements[this.currentContainer.key].trigger('click');
        } else {
            this.currentContainer = !this.currentContainer;
        }
    }

    _openMergeTagModal() {
        return mergeTagModalCreator(
            this.injector,
            {
                guestlistId: null,
                hideNonGuestlist: true,
                scopedGuestlists: [],
                entityPrefix: 'tickets/templates'
            }
        );
    }

    _fillIframe(newContent) {
        const iFrameContainer = angular.element('#ticket_preview_container'),
            iFrame = iFrameContainer.find('#ticket_editor_preview');

        iFrameContainer.css('height', 'auto');
        iFrame.css({
            'transform': 'none'
        });

        let scaleRatio = 1;
        if (iFrame.width() > iFrameContainer.width()) {
            scaleRatio = Math.round((iFrameContainer.width() / iFrame.width()) * 10000) / 10000;

            iFrame.css({
                'transform': 'scale(' + scaleRatio + ')'
            });
        }

        iFrameContainer.css('height', (iFrame.height() * scaleRatio) + 'px');

        this.containerElements = {};

        if (iFrame && iFrame[0]) {
            const iFrameDocument = iFrame[0].contentWindow.document;

            iFrame.on('load', () => {
                    const iFrameContent = iFrame.contents(),
                        headElement = iFrameContent.find('head'),
                        injectStyleTag = $('<style>');

                    injectStyleTag.appendTo(headElement);

                    injectStyleTag.text(
                        `.al-ticket-template-container:before {
                        position: absolute;
                        display: block; 
                        content: "";
                        left: 0;
                        top: 0;
                        right: 0;
                        bottom: 0;
                        border: 2px dashed #e9eef4;
                        margin-bottom: 2px;
                    } 
                    .al-ticket-template-container:hover:before {
                        border-color: #bb94ff;
                    } 
                    .al-ticket-template-container-active:before {
                        border-color: #9C63FF;
                    }`
                    );

                    _.each(this.templateType.definition.containers, (container) => {
                        const containerElement = iFrameContent.find(`#${container.element_id}`);
                        if (containerElement.length === 0) {
                            console.error('container not found', container);
                            return;
                        }
                        this.containerElements[container.key] = containerElement;

                        if (container === this.currentContainer) {
                            containerElement.addClass('al-ticket-template-container-active');
                        }

                        containerElement.off('click');
                        containerElement.on('click', () => {
                            iFrameContent.find('.al-ticket-template-container-active').removeClass('al-ticket-template-container-active');
                            if (this.currentContainer === container) {
                                this.currentContainer = null;
                            } else {
                                this.currentContainer = container;
                                containerElement.addClass('al-ticket-template-container-active');
                            }
                            this.scope.$applyAsync();
                        });
                        containerElement.addClass('al-ticket-template-container');
                    });
                }
            );

            iFrameDocument.open();
            iFrameDocument.write(newContent);
            iFrameDocument.close();
        }
    }

    _prepareHtmlPreview(index) {
        if (this.originalTemplate.type !== 'predefined_type') {
            this.updatingPreview = false;
            return;
        }
        this.updatingPreview = true;

        this.api
            .post(`tickets/templates/types/${this.templateType.id}/render-from-definition`, {
                rsvp_id: this.previewRsvpId,
                definition: {
                    ...this.definitionModel
                }
            }, {
                ignoreLoadingBar: true
            })
            .then(({data}) => {
                if (index === this.currentPreviewIndex) {
                    this.updatingPreview = false;
                    this._fillIframe(data);
                }
            })
            .catch((e) => {
                this.alert.handle(e);
            })
    }

    _loadTemplateTypeInformation() {
        // Loading fonts
        this.api.get(`tickets/templates/types/${this.templateType.id}/available-fonts`)
            .then(({data}) => {
                this.availableFonts = data.data;
            })
    }

    _initWatchers() {
        this.scope.$watch(
            () => this.definitionModel,
            () => {
                this._handlePrepareHtmlPreview();
                this._triggerUpdate();
            },
            true
        )
        this.scope.$watch(
            () => this.previewRsvpId,
            () => {
                this._handlePrepareHtmlPreview();
            }
        )

        this.scope.$watch(
            () => this.model,
            () => {
                this._triggerUpdate();
            },
            true
        )
    }

    _handlePrepareHtmlPreview() {
        if (this.loading) {
            return;
        }

        const currentIndex = ++this.currentPreviewIndex;
        this.timeout(() => {
            if (currentIndex === this.currentPreviewIndex) {
                this._prepareHtmlPreview(currentIndex);
            }
        }, 400)

    }

    _updateModelFromOriginalModel() {
        if (
            !this.originalTemplate
            || !this.originalModel
        ) {
            return;
        }

        this.model = _.cloneDeep(this.originalModel);

        if (this.originalTemplate.type === 'predefined_type') {
            this._initPredefinedTypeEditor();
        }

        this.loading = false;
        this._prepareHtmlPreview();
    }

    _prepareModelForApi() {
        return {
            ...this.model,
            type_definition: _.cloneDeep(this.definitionModel)
        };
    }

    _triggerUpdate() {
        const newModel = this._prepareModelForApi();

        this.model = newModel;
        this.onModelChange({
            model: _.cloneDeep(newModel)
        })
    }

    _initPredefinedTypeEditor() {
        this.templateType = this.originalTemplate.template_type;
        this._loadTemplateTypeInformation();

        let defaultDefinitionModel = {
            fonts: {},
            containers: {},
            global_settings: {}
        };

        _.each(this.templateType.definition.containers, (container) => {
            _.each(container.settings, (setting) => {
                if (_.isUndefined(defaultDefinitionModel.containers[container.key])) {
                    defaultDefinitionModel.containers[container.key] = {
                        settings: {}
                    };
                }
                defaultDefinitionModel.containers[container.key].settings[setting.key] = setting.value;
            })
        });

        _.each(this.templateType.definition.global_settings, (setting) => {
            defaultDefinitionModel.global_settings[setting.key] = setting.value;
        });

        _.each(this.templateType.definition.fonts, (font) => {
            defaultDefinitionModel.fonts[font.key] = font.values;
        });

        this.definitionModel = _.defaultsDeep(this.originalModel.type_definition, defaultDefinitionModel);
    }
}

TicketTemplateEditorController
    .$inject = [
    '$scope',
    '$injector'
];



// WEBPACK FOOTER //
// ./src/app/modules/tickets/templates/components/al-ticket-template-editor/controller.js